import { render } from "./HomeArchiveEntryMark.vue?vue&type=template&id=87e77c6a&scoped=true"
import script from "./HomeArchiveEntryMark.vue?vue&type=script&lang=js"
export * from "./HomeArchiveEntryMark.vue?vue&type=script&lang=js"

import "./HomeArchiveEntryMark.vue?vue&type=style&index=0&id=87e77c6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87e77c6a"]])

export default __exports__